<template>
    <div class="charge-warp" v-loading="loading">
        <div class="display-f just-b align-i-c">
            <el-form ref="form" :model="searchForm" inline>
                <el-form-item>
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date" type="datetimerange" :default-time="['00:00:00', '23:59:59']"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="患者姓名/手机号码" v-model="searchForm.searchValue"></el-input>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="handleReset">重置</custom-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-warp">
            <customTable height="600" :cell-style="{ borderColor: '#DDDDDD' }" @pageChange="pageChange" :total="total"
                tooltip-effect="dark" :tableData="tableData" :column="column" :currentPage="searchForm.pageNum"
                :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
                <template slot="discount">
                    <div>
                        <span>议价 </span>
                        <el-tooltip class="item" effect="dark" content="加价展示正数，减价展示负数" placement="top-start">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </template>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear } from '@/utils/validateBase'
import { loading } from '../../../../utils/validateBase';
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                searchValue: '',
                pageNum: 1,
                pageSize: 10
            },//搜索条件
            tableData: [],//表格数据
            total: 0,//总数
            column: [
                { label: "日期", prop: "createTime", width: 208, align: 'left' },
                { label: "患者", prop: "patientName", align: 'left', showOverflowTooltip: true },
                {
                    label: "性别", prop: "sex", width: 82, align: 'left', formatter: (row => {
                        return row.sex == '1' ? '女' : '男'
                    })
                },
                { label: "年龄", prop: "age", width: 82, align: 'left' },
                { label: "手机号", prop: "phone", width: 148, align: 'left' },
                { label: "原价", prop: "totalPrice", width: 124, align: 'right' },
                { label: "议价", prop: "discount", width: 124, align: 'right', },
                { label: "应收", prop: "amount", width: 124, align: 'right' },
                { label: "实收", prop: "payPrice", width: 124, align: 'right' },
                { label: "欠费", prop: "arrears", width: 124, align: 'right' },
                { label: "门诊单号", prop: "orderNumber", align: 'left', showOverflowTooltip: true },
            ],//表头
            loading: false, // 全局loading
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        let time = CommonDTO.getSystemTimeDTO()
        let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
	    let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
        this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
        this.queryArrearsOrder()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 页码改变
         */
        pageChange(obj) {
            let { current, size } = obj
            this.searchForm.pageNum = current
            this.searchForm.pageSize = size
            this.queryArrearsOrder()
        },
        /**
         * 重置
         */
        handleReset() {
            this.searchForm = {
                date: [],
                searchValue: '',
                pageNum: 1,
                pageSize: 10
            }
            let time = CommonDTO.getSystemTimeDTO()
            this.searchForm.date[0] = Utils.timeFormat(Number(Utils.startOfDay(moment(time))), 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.date[1] = Utils.timeFormat(Number(Utils.endOfDay(moment(time))), 'yyyy-MM-DD HH:mm:ss')
            this.queryArrearsOrder()
        },

        /**
         * 搜索
         */
        handleSearch() {
            if(_.isEmpty(this.searchForm.date)){
                this.$message.error('请选择时间')
                return
            }
            this.searchForm.pageNum = 1
            let flag = this.searchForm.date&&isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            this.queryArrearsOrder()
        },

        /**
         * 查询欠费订单
         */
        async queryArrearsOrder() {
            this.searchForm.startTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
            this.searchForm.stopTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
            this.loading = true
            let { code, rows, total } = await statementDTO.queryArrearsOrder(this.searchForm)
            this.loading = false
            if (code == 200) {
                this.tableData = rows
                this.total = total
            }
        },

    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;

        /deep/.el-table {
            border-color: #DDDDDD;
        }

        /deep/.pagination-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 0;

            .total-tips {
                color: #667182;
                font-size: 14px;
            }
        }
    }
}</style>